import { FeatureFlag } from '@ps/web-core-enums';
import { useFeature } from '@ps/web-core-store';

type VerificationStrategy = 'sumsub' | 'idscan' | 'incode';

export const useVerificationStragety = (): VerificationStrategy => {
  const VerifyDocSecondary: boolean = useFeature(FeatureFlag.VerifyDocSecondary);
  const verifyDoc: boolean = useFeature(FeatureFlag.VerifyDoc);

  return VerifyDocSecondary ? 'incode' : verifyDoc ? 'sumsub' : 'idscan';
};
